import { Link, useLocation } from 'react-router-dom'
import _ from "lodash";
import { IoIosArrowDown } from "react-icons/io";

export default function DropdownMenu({ menu }) {
    const location = useLocation();
    const { pathname } = location;
    const links = _.map(menu.links, (m) => m.link);

    return (
        <div className="dropdown">
            <button
                className={`dropbtn ${links.includes(pathname.substring(1))
                    ? "active-link"
                    : "inactive-link"
                    }`}
            >
                {menu.label} <IoIosArrowDown />
            </button>
            <div className="dropdown-content">
                {menu.links.map((m, i) => (
                    <Link key={i} to={`/${m.link}`}>
                        {m.label}
                    </Link>
                ))}
            </div>
        </div>
    )
}


